<template>
  <div>
    <div class="Fuell-Overlay"></div>
    <div class="Fuell-Modal">
      <div class="Fuell-Modal--window centered">
        <button
          class="Fuell-Modal--close-button"
          @click="closeModal"
        >
          <img
            :src="require('@/assets/img/icons/close.svg')"
            alt="close"
          />
        </button>

        <h3
          class="Fuell-Modal--title"
          v-t.preserve="{ path: 'dashboard_account_box_make_payment_wire_transfer_title' }"
        ></h3>
        <template v-if="!errorFlag">
        <p class="Fuell-Text">
          {{$t('dashboard_account_box_make_payment_text_1')}}<br>
          {{$t('dashboard_account_box_make_payment_text_2')}}
        </p>

        <div class="flex d-flex-sm Fuell-Text details">
          <div
            class="column"
            v-t.preserve="{path: 'dashboard_make_payment_bank_transfer_subject'}"
          ></div>
          <div class="column">

            {{paymentInformation.transactionSubject}}
            <button
              type="button"
              @click="copyToClipboard('concept')"
              class="Fuell-IconButton Fuell-IconButton--no-margin copy"
            >
              <img
                alt="icon-copy"
                :src="require('@/assets/img/icons/icon-copy.svg')"
              />
            </button>
            <input
              type="hidden"
              id="concept"
              :value="paymentInformation.transactionSubject"
            >
          </div>

          <div
            class="column"
            v-t.preserve="{path: 'dashboard_make_payment_bank_account_holder'}"
          ></div>
          <div class="column">
            {{paymentInformation.transactionAccountHolder}}
            <button
              type="button"
              @click="copyToClipboard('target')"
              class="Fuell-IconButton Fuell-IconButton--no-margin copy"
            >
              <img
                alt="icon-copy"
                :src="require('@/assets/img/icons/icon-copy.svg')"
              />
            </button>
            <input
              type="hidden"
              id="target"
              :value="paymentInformation.transactionAccountHolder"
            >
          </div>

          <div
            class="column"
            v-t.preserve="{path: 'dashboard_make_payment_bank_account'}"
          ></div>
          <div class="column">
            {{bankAccountNumber}}
            <button
              type="button"
              @click="copyToClipboard('account')"
              class="Fuell-IconButton Fuell-IconButton--no-margin copy"
            >
              <img
                alt="icon-copy"
                :src="require('@/assets/img/icons/icon-copy.svg')"
              />
            </button>
            <input
              type="hidden"
              id="account"
              :value="bankAccountNumber"
            >
          </div>
          <!-- Ocultar hasta confirmar
          <div
            class="column"
            v-t.preserve="{path: 'dashboard_make_payment_bank_swift_code'}"
          ></div>
          <div class="column">
            {{swiftCode}}
            <button
              type="button"
              @click="copyToClipboard('swift')"
              class="Fuell-IconButton Fuell-IconButton--no-margin copy"
            >
              <img
                alt="icon-copy"
                :src="require('@/assets/img/icons/icon-copy.svg')"
              />
            </button>
            <input
              type="hidden"
              id="swift"
              :value="swiftCode"
            >
          </div>
        -->
        </div>

      </template>
      <template v-else>
        <p class="Fuell-Text text-danger">{{$t('dashboard_account_box_make_transfer_fetch_info_error')}}</p>

      </template>
      </div>
    </div>
  </div>
</template>

<script>
import _modalHandlerMixin from '@/components/Commons/_mixins/_modalHandlerMixin'
import dashboardApi from '../_api'

export default {
  name: 'MakeTransferPaymentModal',
  mixins: [_modalHandlerMixin],
  data () {
    return {
      paymentInformation: {},
      errorFlag: false
    }
  },
  computed: {
    userOfficeId () {
      if (
        this.$store.getters['CompanyStore/currentCompany'] &&
        this.$store.getters['CompanyStore/currentCompany'].id
      ) {
        return this.$store.getters['CompanyStore/currentCompany'].id
      } else {
        return this.$store.getters['LoginStore/user'].office_id
      }
    },
    bankAccountNumber () {
      return this.paymentInformation?.transactionAccountNumber ? this.paymentInformation.transactionAccountNumber.trim() : ''
    },
    swiftCode () {
      // return this.paymentInformation && this.paymentInformation.transactionAccountNumber ? this.paymentInformation.transactionAccountNumber.split('/')[1].trim() : ''
      return ''
    }
  },
  methods: {
    async fetchPaymentInformation () {
      try {
        const response = await dashboardApi.getPaymentInformation(this.userOfficeId)
        this.paymentInformation = response.data
      } catch (error) {
        this.errorFlag = true
      }
    },
    copyToClipboard (item) {
      let itemToCopy = document.querySelector(`#${item}`)
      itemToCopy.setAttribute('type', 'text')
      itemToCopy.select()
      try {
        let success = document.execCommand('copy')
        if (success) {
          this.$store.dispatch('SnackBars/addSuccess', this.$t('ACTION_COPY_TO_CLIPBOARD'), { root: true })
        }
      } catch (error) {
        console.log('error copiando')
      }
      itemToCopy.setAttribute('type', 'hidden')
      window.getSelection().removeAllRanges()
    },
    handleCardPayment () {
      this.closeModal()
      this.$emit('handleCardPayment')
    }
  },
  watch: {
    officeId: {
      handler: 'fetchPaymentInformation',
      immediate: true
    }
  }

}
</script>

<style lang="scss" scoped>
.Fuell-Modal--window {
  max-width: 700px;
  @media screen and (max-width: 576px) {
    height: 100vh;
    max-height: 100vh;
  }
}

.data-grid div:nth-child(even) {
  text-align: right;
}

.flex {
  flex-wrap: wrap;
}

.column {
  line-height: 30px;
  flex-basis: 50%;
  display: flex;
  align-items: center;
}

.column:nth-child(odd) {
  justify-content: flex-end;
  padding-right: 15px;
}

.details {
  color: var(--text-heading);
  @media screen and (max-width: 576px) {
    margin-top: 40px;
  }
}

.copy {
  margin-left: 10px;
}
</style>
